export default function PaymentPage({ t }) {
    const transactions = [
        { id: "TXN-8821", amount: 284.5, method: "Visa", status: "completed", time: "14:32" },
        { id: "TXN-8820", amount: 56.0, method: "八達通", status: "completed", time: "14:18" },
        { id: "TXN-8819", amount: 1200.0, method: "Mastercard", status: "pending", time: "13:55" },
        { id: "TXN-8818", amount: 33.9, method: "PayMe", status: "failed", time: "13:40" },
        { id: "TXN-8817", amount: 470.0, method: "Visa", status: "completed", time: "13:12" },
    ];

    const statusStyle = (s) => ({
        completed: { bg: `${t.success}22`, color: t.success, label: "✓ 成功" },
        pending: { bg: "#f59e0b22", color: "#f59e0b", label: "⏳ 處理中" },
        failed: { bg: `${t.danger}22`, color: t.danger, label: "✕ 失敗" },
    }[s]);

    const totalToday = transactions.filter((x) => x.status === "completed").reduce((s, x) => s + x.amount, 0);

    return (
        <div style={{ padding: 32 }}>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: t.text, margin: "0 0 24px" }}>💰 支付模組</h2>

            {/* KPI */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 24 }}>
                {[
                    { label: "今日成功交易", value: `HK$${totalToday.toFixed(0)}`, icon: "💵", positive: true },
                    { label: "交易筆數", value: transactions.filter((x) => x.status === "completed").length, icon: "📋", positive: true },
                    { label: "待處理", value: transactions.filter((x) => x.status === "pending").length, icon: "⏳", positive: false },
                    { label: "失敗交易", value: transactions.filter((x) => x.status === "failed").length, icon: "⚠️", positive: false },
                ].map((k, i) => (
                    <div key={i} style={{ background: t.surface, borderRadius: 12, padding: 18, border: `1px solid ${t.border}` }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                            <span style={{ fontSize: 22 }}>{k.icon}</span>
                            <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 20, background: k.positive ? `${t.success}22` : `${t.danger}22`, color: k.positive ? t.success : t.danger }}>
                                {k.positive ? "正常" : "注意"}
                            </span>
                        </div>
                        <p style={{ fontSize: 26, fontWeight: 800, color: t.text, margin: "0 0 4px" }}>{k.value}</p>
                        <p style={{ color: t.textMuted, fontSize: 12, margin: 0 }}>{k.label}</p>
                    </div>
                ))}
            </div>

            {/* Transaction Table */}
            <div style={{ background: t.surface, borderRadius: 12, border: `1px solid ${t.border}`, overflow: "hidden" }}>
                <div style={{ padding: "16px 20px", borderBottom: `1px solid ${t.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ color: t.text, fontSize: 16, fontWeight: 700, margin: 0 }}>📋 今日交易記錄</h3>
                    <span style={{ color: t.textFaint, fontSize: 13 }}>2026-06-15</span>
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ background: t.inputBg }}>
                            {["交易 ID", "金額", "付款方式", "狀態", "時間"].map((h) => (
                                <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: t.textFaint, fontSize: 12, fontWeight: 600, borderBottom: `1px solid ${t.border}` }}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((tx) => {
                            const s = statusStyle(tx.status);
                            return (
                                <tr key={tx.id} style={{ borderBottom: `1px solid ${t.border}` }}>
                                    <td style={{ padding: "12px 16px" }}><code style={{ background: t.inputBg, color: t.accentText, padding: "2px 6px", borderRadius: 4, fontSize: 12 }}>{tx.id}</code></td>
                                    <td style={{ padding: "12px 16px", color: t.text, fontSize: 14, fontWeight: 700 }}>HK${tx.amount.toFixed(1)}</td>
                                    <td style={{ padding: "12px 16px", color: t.textMuted, fontSize: 13 }}>{tx.method}</td>
                                    <td style={{ padding: "12px 16px" }}><span style={{ fontSize: 12, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: s.bg, color: s.color }}>{s.label}</span></td>
                                    <td style={{ padding: "12px 16px", color: t.textFaint, fontSize: 13 }}>{tx.time}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}